import { Meal, Symptom, WeeklyInsight } from './types';

export const INITIAL_MEALS: Meal[] = [];

export const INITIAL_SYMPTOMS: Symptom[] = [];


export const INITIAL_INSIGHTS: WeeklyInsight[] = [
  {
    generated_at_iso: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    week_range: 'Past 7 Days Digest',
    ai_summary_markdown: `### 🔍 AI Delayed Intolerance Analysis (LLaMA 3.1)

Based on an analysis of **14 meals** and **8 digestive check-ins** over the last 7 days, clear delayed reaction patterns have emerged:

1. **Next-Morning Bloating Correlation (10–14 hour lag)**:
   - Dinners containing **Heavy Dairy (Cream, Parmesan)** and **High-FODMAP Garlic** strongly correlate with moderate-to-severe next-morning distension (Score: 4/5) upon waking.
   - Specifically, evening consumption of alliums (garlic/onion) triggered next-morning lower abdominal pressure in 3 out of 3 tracked occurrences.

2. **Well-Tolerated Baseline**:
   - Oats, blueberries, quinoa, and lean proteins (chicken, salmon) consistently register Bloating Score 1/5 and Soreness Score 1/5.

### 💡 Clinical Advice for the Coming Week
- **Test Elimination**: Consider substituting garlic-infused olive oil for whole cooked garlic in dinner meals.
- **Dairy Window**: Switch evening dairy to lactose-free alternatives or plant-based fats to verify whether whey/casein vs. fructans is the primary driver.`,
    suspected_triggers: 'Garlic (8-14h lag), Cream/Dairy (10-12h lag), Wheat Pasta',
    safe_foods: 'Oats, Blueberries, Quinoa, Chicken, Olive Oil, Avocado'
  }
];
